import { Components, Theme } from '@mui/material/styles';

export const MuiToolbar: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    root: {
      minHeight: 64,
      paddingLeft: 16,
      paddingRight: 16,
      '@media (min-width:600px)': {
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
  },
};
